import styled from 'styled-components';

export const IncompleteModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  max-width: 400px;
  height: 400px;
  padding: 0 24px;

  .incomplete-register-modal__title {
    margin-top: 19px;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    color: #152946;
    letter-spacing: 0.36px;
  }

  .incomplete-register-modal__text {
    margin-top: 26px;
    text-align: center;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #152946;
    &.secondary {
      margin-top: 15px;
    }
  }

  .incomplete-register-modal__buttons {
    margin-top: 48px;
    margin-bottom: 48px;
  }
`;
